<template>
  <vs-row>
    <vs-row v-if="!isAddingNote" vs-justify="space-between">
      <h2 class="font-bold text-sm mb-1">Internal notes</h2>
      <vs-button
        @click="handleAddNoteClick"
        :disabled="disableComponent"
        >Add note</vs-button
      >
    </vs-row>
    <vs-row v-if="isAddingNote">
      <vs-col>
        <vs-row>
          <label class="vs-input--label">Note (internal)</label>
          <vs-textarea
            placeholder="Add a note"
            v-model="newNote.message"
            height="150px"
          />
        </vs-row>
        <vs-row vs-justify="flex-end">
          <vs-button
            class="mr-2"
            @click="handleAddClick"
            :disabled="disableComponent"
            >Add</vs-button
          >
          <vs-button type="border" @click="handleCancelClick">Cancel</vs-button>
        </vs-row>
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col v-if="!booking.notes || booking.notes.length === 0">
        No notes on this booking yet.
      </vs-col>

      <vs-col v-if="booking.notes && booking.notes.length > 0">
        <vs-row
          v-for="(note, index) in booking.notes"
          :key="booking.id + '-note-' + index"
        >
          {{ getUserName(note) }} [{{ formatDate(note) }}]: {{ note.message }}
        </vs-row>
      </vs-col>
    </vs-row>
  </vs-row>
</template>

<script>
import moment from "moment";
import { BookingNote } from "@/store/modules/marcom/data-model/bookings";
import { mapGetters } from "vuex";
import { Booking } from "../../../../../../../store/modules/marcom/data-model/bookings";

export default {
  components: {},
  props: {
    booking: Object,
    disableComponent: Boolean,
  },
  model: {
    prop: "booking",
    event: "booking-notes-updated",
  },
  data() {
    return {
      newNote: undefined,
      isAddingNote: false,
    };
  },
  computed: {
    ...mapGetters({
      userId: "users/userId",
      user: "users/user",
    }),
  },
  methods: {
    handleAddNoteClick() {
      setTimeout(() => {
        this.newNote = new BookingNote({ id: this.userId }, "");
        this.isAddingNote = true;
        this.$emit("is-adding-note-changed", this.isAddingNote);
      }, 50);
    },
    handleAddClick() {
      this.booking.notes.push(this.newNote);
      this.$emit(
        "booking-notes-updated",
        Object.assign(new Booking(), this.booking)
      );
      this.closeAddNote();
    },
    handleCancelClick() {
      this.closeAddNote();
    },
    closeAddNote() {
      setTimeout(() => {
        this.isAddingNote = false;
        this.$emit("is-adding-note-changed", this.isAddingNote);
        this.newNote = undefined;
      }, 50);
    },
    getUserName(note) {
      const theUser = this.user(note.createdBy.id);
      return theUser
        ? `${theUser.firstName} ${theUser.lastName}`
        : "Unknown user";
    },
    formatDate(note) {
      let date = moment(note.created);
      return date.format("DD-MM-YYYY HH:mm");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
